export default {
  CAMPAIGN: "CAMPAIGN",
  ADVERTISE: "ADVERTISE",
  PUBLISHER: "PUBLISHER",
  POSITION: "POSITION",
  TIME: "TIME",
};
